import PageHero from "../components/PageHero";
import GalleryGrid from "../components/GalleryGrid";

export default function Revelion() {
  const IMAGINI = [1, 2, 3, 4, 5].map(n => `/images/revelion/${n}.png`);

  return (
    <section>
      <PageHero title="Rochii pentru Revelion" subtitle="Strălucire, confort și impact vizual." />
      <p className="mb-6">Se pot integra paiete, lurex, catifea sau satin, în funcție de preferințe.</p>
      <GalleryGrid items={IMAGINI} />
    </section>
  );
}
